"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var removeFirstInstance = exports.removeFirstInstance = function removeFirstInstance(arr, item) {
  var index = arr.indexOf(item);
  if (index !== -1) {
    return [].concat(_toConsumableArray(arr.slice(0, index)), _toConsumableArray(arr.slice(index + 1)));
  }
  return arr;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/remove-first-instance/index.js
// module id = 588
// module chunks = 0